
import { CopyType } from '@/const/lits';
import { IMission } from '@/interface';
import { postMaterial } from '@/utils/material';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiResp } from './cgi';
import { resetRichMediaValue } from './mission';
import { API_PREFIX, request } from './request';

/**
 * 保存信息
 */
export const modifyPropsDetail = async (sceneId: string, mission?: IMission) => {
  const { materialMap, ...postData }: any = mission || {};
  postData.materialMap = postMaterial(postData, materialMap);

  const result: any = transformObjectDeep({ mission: { ...postData }, sceneId }, 'snake');
  const tempMissionEvents = resetRichMediaValue(result?.mission.assets_event || []);

  const resultPostData = {
    ...result?.mission,
    assets_event: tempMissionEvents,
  };
  const res = await request(`${API_PREFIX}${apiPathServer.postProps}`, {
    method: 'POST',
    body: resultPostData,
  });
  return res;
};

/**
 * 删除信息
 */
export const deleteProps = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.deleteProps}`, {
    method: 'POST',
    body: { id },
  });
  return res;
};

/**
 * 拉取详情
 */
export const fetchPropsDetail = async ({ id = '', release = false, close = false }) => {
  const res = await request<CgiResp<any>>(`${API_PREFIX}${apiPathServer.propsDetail}${release ? '/release' : ''}`, {
    query: {
      id,
      depth: 2,
      close,
    },
  });
  return transformObjectDeep(res, 'camel') as CgiResp;
};

export const copyProps = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.copy}`, {
    method: 'POST',
    body: { copy_id: id, type: CopyType.PROPS },
  });
  return res;
};

/**
 *  拉取列表
 * @param param0
 * @returns
 */
export const fetchPropsList = async ({
  page = 1,
  size = 10,
  storyId = '',
  release = false,
}: {
  page?: number;
  size?: number;
  storyId?: string;
  release?: boolean
}): Promise<{
  list: IMission[];
  pageInfo: {
    total: number;
    current: number;
    pageSize: number;
  }
}> => {
  const res = await request(`${API_PREFIX}${apiPathServer.propsList}${release ? '/release' : ''}`, {
    query: {
      page,
      size,
      story_id: storyId,
    },
  });
  const { list = [], pageinfo: pageInfo } = res?.data || {};
  return {
    list: list?.map((item: any) => transformObjectDeep(item, 'camel')) || [],
    pageInfo: {
      total: pageInfo?.total || 0,
      current: pageInfo?.page || 1,
      pageSize: pageInfo?.size || 10,
    },
  };
};
